export default class Martyr
{
    constructor(instructions, specifications, martyr_info, beneficial_info, applicant_info, family_info){
        this.instructions       = instructions
        this.specifications     = specifications
        this.martyr_info        = martyr_info
        this.beneficial_info    = beneficial_info
        this.applicant_info     = applicant_info
        this.family_info        = family_info
    }

    toFormData(){
        let fData = new FormData()
        
        //مواصفات الوحدة السكنية 
        fData.append('housing_city_id', this.specifications.city_id);
        fData.append('housing_housing_unit_id', this.specifications.name_residential_unit_id);
        fData.append('housing_housing_unit_type_id', this.specifications.type_residential_unit_id);
        fData.append('housing_housing_unit_area_id', this.specifications.area_residential_unit_id);

        // معلومات الشهيد
        fData.append('martyr_name1', this.martyr_info.name1);
        fData.append('martyr_name2', this.martyr_info.name2);
        fData.append('martyr_name3', this.martyr_info.name3);
        fData.append('martyr_name4', this.martyr_info.name4);
        fData.append('martyr_family_name', this.martyr_info.family_name);
        fData.append('martyr_mother_name', this.martyr_info.mother_name);
        fData.append('martyr_birth_date', this.martyr_info.birth_date);
        fData.append('martyr_marital_status_id', this.martyr_info.marital_status_id);
        fData.append('martyr_certificate_id', this.martyr_info.certificate_id);
        fData.append('martyr_gender_id', this.martyr_info.gender_id);
        fData.append('martyr_city_id', this.martyr_info.city_id);
        fData.append('martyr_retirement_number', this.martyr_info.retirement_number);
        fData.append('martyr_dept', this.martyr_info.dept);
        fData.append('martyr_date_marty', this.martyr_info.date_marty);
        fData.append('martyr_place_marty', this.martyr_info.place_marty);
        fData.append('martyr_no_exists_body', this.martyr_info.missing_martyr_id);

        if(this.martyr_info.government_grants_id.findIndex((x)=>x.id== 10) == -1){
            for (let i = 0; i < this.martyr_info.government_grants_id.length; i++) {
                const element = this.martyr_info.government_grants_id[i];
                fData.append('martyr_grants['+i+']', element.id);            
            }
        }


        // معلومات المستفيدين 
        fData.append('martyr_qssam_attachment', this.beneficial_info.attachment_qssam);
        for (let i = 0; i < this.beneficial_info.fields.length; i++) {
            const element = this.beneficial_info.fields[i];
            
            fData.append('heirs['+i+'][name1]', element.name1);
            fData.append('heirs['+i+'][name2]', element.name2);
            fData.append('heirs['+i+'][name3]', element.name3);
            fData.append('heirs['+i+'][name4]', element.name4);
            fData.append('heirs['+i+'][phone]', element.phone1);
            fData.append('heirs['+i+'][relation_relative_id]', element.relative_relation_id);
            fData.append('heirs['+i+'][address]', element.home_adress);
            fData.append('heirs['+i+'][pension_amount]', element.salary);
        }

        // معلومات مقدم الطلب 
        fData.append('beneficiary_name1', this.applicant_info.name1);        
        fData.append('beneficiary_name2', this.applicant_info.name2); 
        fData.append('beneficiary_name3', this.applicant_info.name3);                   
        fData.append('beneficiary_name4', this.applicant_info.name4);
        fData.append('beneficiary_family_name', this.applicant_info.family_name);        
        fData.append('beneficiary_mother_name', this.applicant_info.mother_name); 
        fData.append('beneficiary_birth_date', this.applicant_info.birth_date);                   
        fData.append('beneficiary_gender_id', this.applicant_info.gender_id);
        fData.append('beneficiary_phone', this.applicant_info.phone1);        
        fData.append('beneficiary_phone2', this.applicant_info.phone2);        
        fData.append('beneficiary_marital_status_id', this.applicant_info.marital_status_id); 
        fData.append('beneficiary_certificate_id', this.applicant_info.certificate_id);                   
        fData.append('beneficiary_specialization', this.applicant_info.academic_specialization);
        
        if(this.applicant_info.id_type == '1'){
            fData.append('beneficiary_nationality_number', this.applicant_info.nationality_number);
        }else{
            fData.append('beneficiary_national_id_number', this.applicant_info.national_id_number);
            fData.append('beneficiary_national_id_number_paper', this.applicant_info.national_id_number_paper);
            fData.append('beneficiary_national_id_number_record', this.applicant_info.national_id_number_record);
        }

        fData.append('beneficiary_address_city_id', this.applicant_info.city_id);        
        fData.append('beneficiary_address_district', this.applicant_info.district); 
        fData.append('beneficiary_address_region', this.applicant_info.region);                   
        fData.append('beneficiary_address_mahla', this.applicant_info.mahla);
        fData.append('beneficiary_address_zqaq', this.applicant_info.zqaq);        
        fData.append('beneficiary_address_dar', this.applicant_info.dar);

        fData.append('beneficiary_housing_info_real_estate_id', this.applicant_info.own_property_id);
        fData.append('beneficiary_housing_info_accommodation_id', this.applicant_info.house_type_id);                   
        fData.append('beneficiary_housing_info_build_material_type_id', this.applicant_info.construction_type_id);
        fData.append('beneficiary_housing_info_address_privacy_id', this.applicant_info.housing_privacy_id);        
        fData.append('beneficiary_housing_info_building_condition_id', this.applicant_info.construction_condition_id); 
        fData.append('beneficiary_housing_info_area', this.applicant_info.housing_area);                   
        fData.append('beneficiary_housing_info_floors_number', this.applicant_info.number_floors);

        for (let i = 0; i < this.applicant_info.health_status_id.length; i++) {
            const element = this.applicant_info.health_status_id[i];
            fData.append('beneficiary_health_statuses['+i+']', element.id);            
        }
        
        fData.append('beneficiary_relation_relative_id', this.applicant_info.relative_relation_id); 
        fData.append('beneficiary_job_id', this.applicant_info.job_id); 
        if (this.applicant_info.job_id == 3) {
            fData.append('beneficiary_job_title', this.applicant_info.Workplace);
        }
        fData.append('beneficiary_basic_attachment', this.applicant_info.attachment_basic);    

        // معلومات عائلة مقدم الطلب 
        for (let i = 0; i < this.family_info.fields.length; i++) {
            const element = this.family_info.fields[i];
            
            fData.append('beneficiary_family['+i+'][name1]', element.name1); 
            fData.append('beneficiary_family['+i+'][name2]', element.name2); 
            fData.append('beneficiary_family['+i+'][name3]', element.name3); 
            fData.append('beneficiary_family['+i+'][name4]', element.name4); 
    
            fData.append('beneficiary_family['+i+'][gender_id]', element.gender_id); 
            fData.append('beneficiary_family['+i+'][relation_relative_id]', element.relative_relation_id); 
        }

        return fData
    }
}

